/* O+ Stores — B5 walk: scroll reveals + review sliders */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var QUOTE_MS = 5200;

  // Mark JS live so reveal styles apply (CSS no-JS keeps content visible).
  document.documentElement.classList.add('js-walk');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function showAll(root) {
    root.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-inview'); });
    root.querySelectorAll('.o-walk__photo').forEach(function (el) { el.classList.add('is-inview'); });
    root.querySelectorAll('.o-walk__store').forEach(function (el) { el.classList.add('is-visible'); });
  }

  function initQuoteSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-quote-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-quote-dot]'));
    if (slides.length < 2) return;

    var i = 0;
    var timer = null;
    var paused = false;

    function setHeight() {
      var track = root.querySelector('.o-walk__quotes-track');
      if (!track) return;
      var max = 0;
      slides.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.classList.add('is-active');
        clone.removeAttribute('aria-hidden');
        clone.style.cssText = 'position:static;visibility:hidden;opacity:0;pointer-events:none;transform:none;height:auto;';
        track.appendChild(clone);
        max = Math.max(max, clone.offsetHeight || 0);
        track.removeChild(clone);
      });
      if (max > 0) root.style.setProperty('--o-walk-quote-h', max + 'px');
    }

    function go(n, user) {
      if (!slides.length) return;
      i = ((n % slides.length) + slides.length) % slides.length;
      slides.forEach(function (slide, idx) {
        var on = idx === i;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (dot, idx) {
        var on = idx === i;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (user) restart();
    }

    function next() { go(i + 1, false); }

    function stop() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (REDUCED || paused || document.hidden || !inView) return;
      timer = window.setTimeout(function tick() {
        next();
        if (!REDUCED && !paused && !document.hidden && inView) {
          timer = window.setTimeout(tick, QUOTE_MS);
        } else {
          timer = null;
        }
      }, QUOTE_MS);
    }

    function restart() {
      stop();
      start();
    }

    var inView = true;
    if ('IntersectionObserver' in window) {
      var ioQ = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting && entry.intersectionRatio > 0.2;
          if (inView) start();
          else stop();
        });
      }, { threshold: [0, 0.2, 0.5] });
      ioQ.observe(root);
    }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { go(idx, true); });
    });

    root.addEventListener('mouseenter', function () {
      paused = true;
      stop();
    });
    root.addEventListener('mouseleave', function () {
      paused = false;
      start();
    });
    root.addEventListener('focusin', function () {
      paused = true;
      stop();
    });
    root.addEventListener('focusout', function (ev) {
      if (root.contains(ev.relatedTarget)) return;
      paused = false;
      start();
    });

    // Light swipe
    var startX = null;
    root.addEventListener('touchstart', function (ev) {
      if (!ev.touches || !ev.touches.length) return;
      startX = ev.touches[0].clientX;
      stop();
    }, { passive: true });
    root.addEventListener('touchend', function (ev) {
      if (startX == null || !ev.changedTouches || !ev.changedTouches.length) {
        start();
        return;
      }
      var dx = ev.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1), true);
      else start();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    go(0, false);
    // Height after fonts/layout
    setHeight();
    window.setTimeout(setHeight, 300);
    window.addEventListener('resize', function () {
      window.requestAnimationFrame(setHeight);
    });
    start();
  }

  ready(function () {
    var roots = document.querySelectorAll('.o-walk');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var revealEls = root.querySelectorAll('[data-reveal]');
      var photos = root.querySelectorAll('.o-walk__photo');
      var stores = root.querySelectorAll('.o-walk__store');

      if (REDUCED || !('IntersectionObserver' in window)) {
        showAll(root);
      } else {
        // Reveal anything already in viewport immediately (IO can be flaky
        // under fast programmatic scroll), observe the rest.
        var inView = function (el) {
          var r = el.getBoundingClientRect();
          return r.top < window.innerHeight * 0.9 && r.bottom > 0;
        };

        var observed = [];
        [revealEls, photos, stores].forEach(function (list) {
          list.forEach(function (el) {
            if (inView(el)) {
              el.classList.add('is-inview');
              if (el.classList.contains('o-walk__store')) el.classList.add('is-visible');
            } else {
              observed.push(el);
            }
          });
        });

        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-inview');
              if (entry.target.classList.contains('o-walk__store')) {
                entry.target.classList.add('is-visible');
              }
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px 8% 0px' });

        observed.forEach(function (el) { io.observe(el); });

        // Fallback: belt-and-braces sweep so nothing stays hidden if IO misses
        // a frame (fast jumps, automation, odd viewports).
        var sweep = function () {
          var vh = window.innerHeight || document.documentElement.clientHeight;
          observed.forEach(function (el) {
            if (el.classList.contains('is-inview')) return;
            var r = el.getBoundingClientRect();
            if (r.top < vh * 1.1 && r.bottom > -100) {
              el.classList.add('is-inview');
              if (el.classList.contains('o-walk__store')) el.classList.add('is-visible');
            }
          });
        };
        var t;
        var onScroll = function () {
          if (t) return;
          t = window.requestAnimationFrame(function () { t = null; sweep(); });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        // initial + timed catches
        sweep();
        setTimeout(sweep, 400);
        setTimeout(sweep, 1200);
      }

      root.querySelectorAll('[data-o-walk-quotes]').forEach(initQuoteSlider);
    });

    document.querySelectorAll('.o-walk__chip[href^="#"]').forEach(function (chip) {
      chip.addEventListener('click', function (ev) {
        var id = chip.getAttribute('href');
        if (!id || id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        ev.preventDefault();
        target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
        target.classList.add('is-visible');
      });
    });
  });
})();
